import '../node_modules/semantic-ui-css/components/button.min.css';
import '../node_modules/semantic-ui-css/components/card.min.css';
import '../node_modules/semantic-ui-css/components/grid.min.css';
import '../node_modules/semantic-ui-css/components/icon.min.css';
import '../node_modules/semantic-ui-css/components/input.min.css';
import '../node_modules/semantic-ui-css/components/list.min.css';
import '../node_modules/semantic-ui-css/components/menu.min.css';
import '../node_modules/semantic-ui-css/components/message.min.css';
import '../node_modules/semantic-ui-css/components/placeholder.min.css';
import App from './components/App.svelte';

const app = new App({
	target: document.getElementById('grid_products')
});

export default app;
